/*
 * @Author: wangjing 175523310@qq.com
 * @Date: 2022-08-03 14:29:10
 * @LastEditors: wangjing 175523310@qq.com
 * @LastEditTime: 2023-02-17 15:37:20
 * @FilePath: \m-mall-dc\src\api\buyCar.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { request } from "@/utils/request";

// 获取订单列表--母单维度
export const listDemand = (data) => {
  return request({
    url: "/order/mall/listDemand",
    method: "POST",
    data: data,
  });
};

// 获取订单列表--子单维度
export const ownListDemand = (data) => {
  return request({
    url: "/order/public/ownListDemand",
    method: "POST",
    data: data,
  });
};

// 公司名称所有数字
export const queryCompanyByUser = () => {
  return request({
    url: "/user/public/queryCompanyByUser",
    method: "GET",
  });
};

export const queryCompanyOptionsByCompanyCode = (data) => {
  return request({
    url: "/user/public/queryCompanyOptionsByCompanyCode",
    method: "GET",
    data: data,
  });
};

export const queryDemandStatusCount = () => {
  return request({
    url: "/order/public/queryDemandStatusCount",
    method: "POST",
  });
};
// 需求单详情 -- 母单维度
export const demandDetail = (demandParentId) => {
  return request({
    url: `/order/mall/demandDetail?demandParentId=${demandParentId}`,
    method: "GET",
  });
};

// 子单纬度订单详情
export const getDemandDetailVo = (data) => {
  return request({
    url: `/order/public/getDemandDetailVo`,
    method: "Post",
    data: data,
  });
};

// 获得需求单明细
export const getlistGroupedDemand = (options) => {
  return request({
    url: "/order/mall/listGroupedDemand",
    method: "GET",
    data: options,
  });
};

// 物流查询
export const getOrderJdeDetail = (demandCode) => {
  return request({
    url: `/order/public/dde580Detail?demandParentCode=${demandCode}`,
    method: "GET",
  });
};

// 销售合同电子签章
export const queryContractConfig = (demandId) => {
  return request({
    url: `/order/public/contract/config?demandId=${demandId}`,
    method: "GET",
  });
};

// 获得商品清单 管理
export const listDemandItem = (params) => {
  return request({
    url: `/order/mall/listDemandItem`,
    method: "GET",
    data: params,
  });
};

// 再次购买
export const repurchaseByDemandParentId = (demandParentId) => {
  return request({
    url: `/order/mall/repurchaseByDemandParentId?demandParentId=${demandParentId}`,
    method: "GET",
  });
};

// 审批待办内容获取
export const getAgencyContent = (params) => {
  return request({
    url: `/order/agencyConfig/public/userReplyContent`,
    method: "POST",
    data: params,
  });
};

// 审批待办内容获取
export const userReplyAgency = (params) => {
  return request({
    url: `/order/agencyConfig/public/userReply`,
    method: "POST",
    data: params,
  });
};

// 获取商品价格和关注信息
export const getCopyToPayByJson = (params) => {
  return request({
    url: `/order/mall/copyToPay`,
    method: "POST",
    data: params,
  });
};

// 获取收款方信息
export const getAccountInfo = (params) => {
  return request({
    url: `/cms/mall/account/queryPageByCompanyId`,
    method: "POST",
    data: params,
  });
};

// 需求单管理列表
export const queryDemandList = (params) => {
  return request({
    url: `/order/mall/listDemand`,
    method: "POST",
    data: params,
  });
};

// 获取需求单金额和手续费
export const queryAllPayMoney = (params) => {
  return request({
    url: `/order/public/allPayMoeny`,
    method: "GET",
    data: params,
  });
};

// 获取需求单信息
export const queryToPayList = (params) => {
  return request({
    url: `/order/public/toPayList`,
    method: "GET",
    data: params,
  });
};

// 获取商品价格和关注信息
export const getCopyTobfPay = (params) => {
  return request({
    url: `/order/mall/copyTobfPay`,
    method: "POST",
    data: params,
  });
};

// 获取商品价格和关注信息
export const queryWebsiteByCompanyIdNoCode = (params) => {
  return request({
    url: `/cms/public/website/queryWebsiteByCompanyIdNoCode`,
    method: "GET",
    data: params,
  });
};

// 获取是否已回复标识
export const getReplySign = (demandCode) => {
  return request({
    url: `/order/public/auditStay/getReplySign?demandCode=${demandCode}`,
    method: "GET",
  });
};

// 审批代表列表
export const getAuditStayList = (params) => {
  return request({
    url: `/order/public/auditStay/getAuditStayList`,
    method: "POST",
    data: params,
  });
};

// 获取是否已回复标识
export const addAuditStay = (params) => {
  return request({
    url: `/order/public/auditStay/addAuditStay`,
    method: "POST",
    data: params,
  });
};

// 获取医院
export const getHospitalByCustomerCode = (params) => {
  return request({
    url: `/order/public/getHospitalByCustomerCode`,
    method: "get",
    data: params,
  });
};

// 获取新增产品线下拉
export const getProductLineList = (params) => {
  return request({
    url: `/order/public/getLineList`,
    method: "POST",
    data: params,
  });
};

// 获取植入产品线下拉
export const getReportLineList = (params) => {
  return request({
    url: `/order/public/getReportLineList`,
    method: "get",
    data: params,
  });
};

//获取下拉列表
export const getSelectList = (params) => {
  return request({
    url: `/order/public/getSelectList`,
    method: "POST",
    data: params,
  });
};

// 查生产批号列表
export const reportProductlineList = (params) => {
  return request({
    url: `/order/public/reportProductlineList`,
    method: "POST",
    data: params,
  });
};

// 上报植入列表查询
export const getReportList = (params) => {
  params.isBack = 0;
  return request({
    url: `/order/public/getReportList`,
    method: "POST",
    data: params,
  });
};

// 根据批号查上报数据 可能有多条
export const getReportByBatchNum = (params) => {
  return request({
    url: `/order/public/getReport`,
    method: "POST",
    data: params,
  });
};

// 根据批号查上报数据 单条
export const getReportByBatchNumSingle = (params) => {
  return request({
    url: `/order/public/getReportBatchNumber`,
    method: "POST",
    data: params,
  });
};

// 上报植入保存 入参是个list 多条
export const saveReport = (params) => {
  return request({
    url: `/order/public/saveReport`,
    method: "POST",
    data: params,
  });
};

// 上报植入更新
export const updateReport = (params) => {
  return request({
    url: `/order/public/updateReport`,
    method: "POST",
    data: params,
  });
};

//获取未关联批号列表
export const getReportNoBatchList = (params) => {
  return request({
    url: `/public/getAuditUnDelete`,
    method: "POST",
    data: params,
  });
};
// 获取已关联批号列表
export const getAuditUnDelete = (params) => {
  return request({
    url: `/order/public/getAuditUnDelete`,
    method: "POST",
    data: params,
  });
};

// 查询站点列表
export const getBusinessSiteByUserId = (params) => {
  return request({
    url: `/user/public/getBusinessSiteByUserId`,
    method: "GET",
    data: params,
  });
};

// 发票列表查询
export const reportInvoiceList = (params) => {
  return request({
    url: `/order/mall/reportInvoice/mallList`,
    method: "POST",
    data: params,
  });
};

// 发票提交
export const reportInvoiceSubmit = (params) => {
  return request({
    url: `/order/mall/reportInvoice/mallSubmit`,
    method: "POST",
    data: params,
  });
};

// 发票详情
export const reportInvoiceDetail = (params) => {
  return request({
    url: `/order/public/reportInvoice/detail`,
    method: "GET",
    data: params,
  });
};

// 上报植入统计
export const implantReportStatistic = (params) => {
  params.isBack = 0;
  return request({
    url: `/order/public/getReportStatistic`,
    method: "POST",
    data: params,
  });
};

// 发票上报统计
export const invoiceReportStatistic = (params) => {
  return request({
    url: `/order/mall/reportInvoice/mallCount`,
    method: "GET",
    data: params,
  });
};

// 发票上报更新
export const invoiceReportUpdate = (params) => {
  return request({
    url: `/order/mall/reportInvoice/mallLineUpdate`,
    method: "POST",
    data: params,
  });
};

// 获取商品上架数量
export const getActiveProduct = (params) => {
  return request({
    url: `/product/public/getActiveProduct`,
    method: "POST",
    data: params,
  });
};

// 是否关注这个站点

export const siteFavCont = (params) => {
  return request({
    url: `/user/public/contains`,
    method: "POST",
    data: params,
  });
};

// 是否关注这个站点
export const toggleSiteFavCont = (params) => {
  return request({
    url: `/user/public/focusCompanyId`,
    method: "POST",
    data: params,
  });
};
